export const branchesTranslations = {
  ar: {
    title: 'الفروع',
    addNew: 'اضافة جديد',
    search: 'بحث عن فرع...',
    logo: 'الشعار',
    name: 'الاسم',
    address: 'العنوان',
    phone: 'تليفون',
    mobile: 'موبايل',
    fax: 'فاكس',
    password: 'الباسورد',
    branchesGroup: 'مجموعة الفروع',
    cashInvoicesStore: 'مخزن الفواتير النقدية',
    cashInvoicesTreasury: 'خزينة الفواتير النقدية',
    cashInvoicesCustomer: 'عميل الفواتير النقدية',
    branchTaxNumber: 'الرقم الضريبي للفرع',
    commercialRegister: 'السجل التجاري',
    upload: 'رفع',
    chooseFile: 'Choose File',
    noFile: 'No file chosen',
    delete: 'حذف',
    clearFields: 'تفريغ الحقول',
    save: 'حفظ',
    edit: 'تعديل',
    deleteAction: 'حذف',
    noBranches: 'لا توجد فروع',
    loading: 'جاري تحميل الفروع...',
    error: 'فشل تحميل الفروع',
    deleteSuccess: 'تم حذف الفرع بنجاح',
    deleteError: 'فشل حذف الفرع',
    saveSuccess: 'تم حفظ الفرع بنجاح',
    saveError: 'فشل حفظ الفرع',
    nameRequired: 'الاسم مطلوب',
    printerName: 'اسم الطابعة',
    confirmDelete: 'هل أنت متأكد من حذف هذا الفرع؟',
    confirmDeleteShort: 'هل أنت متأكد؟',
    saving: 'جاري الحفظ...',
    export: 'تصدير إلى Excel',
    exportSuccess: 'تم تصدير البيانات بنجاح',
    exportError: 'فشل تصدير البيانات',
    generatingPdf: 'جاري توليد PDF...',
    pdfSuccess: 'تم توليد PDF بنجاح',
    pdfError: 'فشل توليد PDF',
    listTitle: 'كشف الفروع',
    confirmDeleteTitle: 'تأكيد الحذف',
    createdBranch: 'تم إنشاء فرع جديد: ',
    updatedBranch: 'تم تحديث فرع: ',
    deletedBranch: 'تم حذف فرع: ',
  },
  en: {
    title: 'Branches',
    addNew: 'Add New',
    search: 'Search branch...',
    logo: 'Logo',
    name: 'Name',
    address: 'Address',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    password: 'Password',
    branchesGroup: 'Branches Group',
    cashInvoicesStore: 'Cash Invoices Store',
    cashInvoicesTreasury: 'Cash Invoices Treasury',
    cashInvoicesCustomer: 'Cash Invoices Customer',
    branchTaxNumber: 'Branch Tax Number',
    commercialRegister: 'Commercial Register',
    upload: 'Upload',
    chooseFile: 'Choose File',
    noFile: 'No file chosen',
    delete: 'Delete',
    clearFields: 'Clear Fields',
    save: 'Save',
    edit: 'Edit',
    deleteAction: 'Delete',
    noBranches: 'No branches',
    loading: 'Loading branches...',
    error: 'Failed to load branches',
    deleteSuccess: 'Branch deleted successfully',
    deleteError: 'Failed to delete branch',
    saveSuccess: 'Branch saved successfully',
    saveError: 'Failed to save branch',
    nameRequired: 'Name is required',
    printerName: 'Printer Name',
    confirmDelete: 'Are you sure you want to delete this branch?',
    confirmDeleteShort: 'Are you sure?',
    saving: 'Saving...',
    export: 'Export to Excel',
    exportSuccess: 'Data exported successfully',
    exportError: 'Failed to export data',
    generatingPdf: 'Generating PDF...',
    pdfSuccess: 'PDF generated successfully',
    pdfError: 'Failed to generate PDF',
    listTitle: 'Branches List',
    confirmDeleteTitle: 'Confirm Delete',
    createdBranch: 'Created branch: ',
    updatedBranch: 'Updated branch: ',
    deletedBranch: 'Deleted branch: ',
  },
  fr: {
    title: 'Succursales',
    addNew: 'Ajouter nouveau',
    search: 'Rechercher une succursale...',
    logo: 'Logo',
    name: 'Nom',
    address: 'Adresse',
    phone: 'Téléphone',
    mobile: 'Mobile',
    fax: 'Fax',
    password: 'Mot de passe',
    branchesGroup: 'Groupe de succursales',
    cashInvoicesStore: 'Magasin des factures de caisse',
    cashInvoicesTreasury: 'Trésorerie des factures de caisse',
    cashInvoicesCustomer: 'Client des factures de caisse',
    branchTaxNumber: 'Numéro fiscal de la succursale',
    commercialRegister: 'Registre du commerce',
    upload: 'Télécharger',
    chooseFile: 'Choisir un fichier',
    noFile: 'Aucun fichier choisi',
    delete: 'Supprimer',
    clearFields: 'Effacer les champs',
    save: 'Enregistrer',
    edit: 'Modifier',
    deleteAction: 'Supprimer',
    noBranches: 'Aucune succursale',
    loading: 'Chargement des succursales...',
    error: 'Échec du chargement des succursales',
    deleteSuccess: 'Succursale supprimée avec succès',
    deleteError: 'Échec de la suppression de la succursale',
    saveSuccess: 'Succursale enregistrée avec succès',
    saveError: 'Échec de l\'enregistrement de la succursale',
    nameRequired: 'Le nom est requis',
    printerName: 'Nom de l\'imprimante',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette succursale?',
    confirmDeleteShort: 'Êtes-vous sûr?',
    saving: 'Enregistrement...',
    export: 'Exporter vers Excel',
    exportSuccess: 'Données exportées avec succès',
    exportError: 'Échec de l\'exportation des données',
  },
}


